import React from 'react';
import ProductCardSkeleton from '../ProductCardSkeleton/ProductCardSkeleton';
import { GridItem, Center, Text } from '@chakra-ui/react';

type ProductListFallBackProps = {
	isLoading?: boolean;
	count?:     number;
	message:    string;
};

const ProductListFallBack = ({
	isLoading = true,
	count = 6,
	message,
}: ProductListFallBackProps) => {
	if (!isLoading) {
		return (
			<GridItem colSpan={3}>
				<Center h={'200px'}>
					<Text textStyle={'s4'}>{message}</Text>
				</Center>
			</GridItem>
		);
	}

	return (
		<React.Fragment>
			{Array.from({ length: count }).map((_, index) => <ProductCardSkeleton key={`product-skeleton-${index}`} />)}
		</React.Fragment>
	);
};

export default ProductListFallBack;